<div class="summary-card" [ngClass]="{ 'is-missing': !estimatedIsfInfo || isInvalid }">
  <div class="summary-card-logo">
    <div class="card-logo">
      <img alt="logo" *ngIf="info.imgSrc" src="assets/icons/{{ info.imgSrc }}.svg" />
    </div>
  </div>
  <div class="summary-card-content">
    <div class="summary-card-header">
      <div>
        <h5>{{ info.title | translate }}</h5>
      </div>
      <div class="summary-card-edit" *ngIf="canEdit">
        <button class="btn btn-link" (click)="gotoEdit()"><i class="fa fa-pencil"></i></button>
      </div>
    </div>
    <div class="container-card-body">
      <ng-container *ngIf="!estimatedIsfInfo">
        <div class="row">
          <div class="col-12">{{ "LABELS.ISF_ENTITY_IS_MISSING" | translate }}</div>
        </div>
      </ng-container>
      <ng-container *ngIf="!!estimatedIsfInfo">
        <div class="row">
          <div class="col-6 card-label">{{ "FORM_LABEL.ENTERED_VALUE" | translate }}</div>
          <div class="col-6">
            <div
              [ngClass]="{ 'text-error': haasEstimationValueInvalid }"
              *ngIf="estimatedIsfInfo.estimatedValue !== null && estimatedIsfInfo.estimatedValue !== undefined"
            >
              {{ estimatedIsfInfo.estimatedValue | currency : DEFAULT_CURRENCY_CODE : "symbol" : "1.2-2" }}
            </div>
            <div class="text-error" *ngIf="!!getValidationText('ESTIMATED_VALUE_TOO_LARGE')">
              {{ getValidationText("ESTIMATED_VALUE_TOO_LARGE") | translate }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-6 card-label">{{ "LABELS.QUANTITY" | translate }}</div>
          <div class="col-6" [ngClass]="{ 'text-error': hasQuantityInvalid }">
            {{ estimatedIsfInfo.quantity }} {{ estimatedIsfInfo.quantityUnit }}
            <div class="text-error" *ngIf="!!getValidationText('QUANTITY_MISSING')">
              {{ getValidationText("QUANTITY_MISSING") | translate }}
            </div>
            <div class="text-error" *ngIf="!!getValidationText('QUANTITY_UNIT_MISSING')">
              {{ getValidationText("QUANTITY_UNIT_MISSING") | translate }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-6 card-label">{{ "LABELS.WEIGHT" | translate }}</div>
          <div class="col-6" [ngClass]="{ 'text-error': hasWeightInvalid }">
            {{ estimatedIsfInfo.weight }}
            {{
              estimatedIsfInfo.weightUnit === enumWeightUnit.KG
                ? WEIGHT_UNIT_KG
                : estimatedIsfInfo.weightUnit === enumWeightUnit.LB
                ? WEIGHT_UNIT_LB
                : ""
            }}
            <div class="text-error" *ngIf="!!getValidationText('WEIGHT_MISSING')">
              {{ getValidationText("WEIGHT_MISSING") | translate }}
            </div>
            <div class="text-error" *ngIf="!!getValidationText('WEIGHT_UNIT_MISSING')">
              {{ getValidationText("WEIGHT_UNIT_MISSING") | translate }}
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>
